import React, { Component } from 'react';
import { GoogleLogin,GoogleOAuthProvider } from '@react-oauth/google';

import config from '../config';
import backend from '../backend';
import manager from '../Manager'
import {User} from '../api_types'

type LoginProps = {
    onsucc? : string 
}
  

class Login extends Component<LoginProps> {


    onSuccess = async (credentialResponse: any) => {
        const token = credentialResponse.credential;
            const userCredentials = await backend.login(token)
            if (userCredentials) {
                manager.onLogin(userCredentials as User, this.props.onsucc)
            }
    }

    render() {
        return (
        <div className="login-box">
            <h2 className="login-title">Kemtai Annotator</h2>
           
            <p>Sign in with your Google account</p>
            <div className="loginButton">
                <GoogleOAuthProvider clientId={config.googleClientId}>
                    <GoogleLogin
                        onSuccess={this.onSuccess}
                        onError={() => {
                            console.log('Login Failed');
                        }}
                        size="large"
                        theme="filled_blue"
                    />
                </GoogleOAuthProvider>
            </div>
        </div>
        )
    }
}

export default Login;